
const routes = [
  {
    path: "/",
    redirect: "/agenda",
    component: () => import("@/layout/Default"),
    name: "Home",
    meta: {
      requiresAuth: true,
    },
    children:[
      {
        path:"/agenda",
        component:() => import("@/pages/Agenda"),
        name: "Agenda",
        children:[
          {
            path:"",
            component: () => import("@/pages/agenda/Agenda")
          },
          {
            path:"confirmdate",
            component:() => import("@/pages/agenda/Confirmdate"),
          },
          {
            path:"paid",
            component:() => import("@/pages/agenda/Paid"),
          },
        ]
      },
      {
        path:"/profile",
        component:() => import("@/pages/Profile"),
      },  
      {
        path:"/my-reservations",
        component:() => import("@/pages/MyReservations"),
      },  
    ]
  },
  {
    path: "/auth",
    redirect: "/auth/login",
    component: () => import("@/layout/Auth"),
    name: "Home",
    meta: {
      requiresAuth: false,
    },
    children:[
      {
        path:"/login",
        component: () => import("@/pages/Login"),
      },
      {
        path:"/forgot",
        component: () => import("@/pages/Forgot"),
      },
      {
        path:"/reset-password",
        component: () => import("@/pages/ResetPassword"),
      },
      {
        path:"/register",
        component: () => import("@/pages/Register"),
      },
    ]
  },
    
]

export default routes;
